/*
 *
 * Misc constants
 *
 */

export const FETCH_STATES = 'app/Booking/FETCH_STATES';
export const FETCH_STATES_SUCCESS = 'app/Booking/FETCH_STATES_SUCCESS';
export const FETCH_STATES_ERROR = 'app/Booking/FETCH_STATES_ERROR';
